import React from 'react';
import { motion } from 'framer-motion';
import { SlideLayout } from '../SlideLayout';
import { AlertCircle } from 'lucide-react';
export function NvidiaDominanceSlide() {
  return <SlideLayout slideNumber={4} totalSlides={20} title="The Incumbent" data-id="element-420">
      <div className="w-full h-full flex flex-col" data-id="element-421">
        <motion.div initial={{
        scale: 0.8,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 1
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6" data-id="element-422">
          <h2 className="text-3xl md:text-4xl font-bold mb-3 text-brand-muted" data-id="element-423">
            Nvidia Dominates the GPU Market
          </h2>
          <div className="text-[110px] md:text-[160px] leading-none font-mono font-bold text-chip-gpu tracking-tighter" data-id="element-424">
            75-90<span className="text-6xl md:text-8xl" data-id="element-425">%</span>
          </div>
          <p className="text-2xl text-brand-muted mt-2" data-id="element-426">
            Estimated GPU Market Share
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 flex-1" data-id="element-427">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="bg-brand-surface border border-brand-border p-7 rounded-xl flex flex-col justify-center" data-id="element-428">
            <h3 className="text-chip-gpu font-bold text-2xl mb-3" data-id="element-429">
              Revenue Juggernaut
            </h3>
            <p className="text-brand-muted text-xl leading-relaxed" data-id="element-430">
              Q4 FY2026 revenue hit{' '}
              <span className="text-white font-mono" data-id="element-431">$68.1B</span> (+73% YoY).
              Absolute demand keeps rising despite alternatives.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.5
        }} className="bg-brand-surface border border-brand-border p-7 rounded-xl flex flex-col justify-center" data-id="element-432">
            <h3 className="text-chip-gpu font-bold text-2xl mb-3" data-id="element-433">CUDA Moat</h3>
            <p className="text-brand-muted text-xl leading-relaxed" data-id="element-434">
              The software ecosystem creates massive lock-in for training
              workloads, keeping competitors at bay.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6
        }} className="bg-brand-surface border border-brand-border p-7 rounded-xl flex flex-col justify-center relative overflow-hidden" data-id="element-435">
            <div className="absolute top-0 right-0 p-2 opacity-10" data-id="element-436">
              <AlertCircle size={64} data-id="element-437" />
            </div>
            <h3 className="text-white font-bold text-2xl mb-3" data-id="element-438">The Catch</h3>
            <p className="text-brand-muted text-xl leading-relaxed" data-id="element-439">
              This figure reflects{' '}
              <span className="text-white font-semibold" data-id="element-440">
                external sales only
              </span>
              . It misses the massive internal compute of hyperscalers building
              their own chips.
            </p>
          </motion.div>
        </div>
      </div>
    </SlideLayout>;
}